// extracted by mini-css-extract-plugin
module.exports = {"actionIcon":"TsaBackendTable_actionIcon__1YEZE","editIcon":"TsaBackendTable_editIcon__3qrti","deleteIcon":"TsaBackendTable_deleteIcon__32ISm"};